import { useEffect, useState } from 'react';
import { GoDotFill } from "react-icons/go";
import { useAuth } from '../../Providers/AuthProvider';
import ZipCodeInputModal from './Modals/ZipCodeInputModal';
import { useParams } from '../../Providers/ParamsProvider';

import './Styles/ProductAvailabilityLevelStyle.css';

/**
 * DK: Komponent wyświetlający poziom dostępności
 * @param {boolean} setIsAvailabilityLevelAdditionalInfoShowed Ustawia czy są wyświetlone dodatkowe informacje w tym komponencie
 * @returns 
 */
const ProductAvailabilityLevel = ({ product, setIsAvailabilityLevelAdditionalInfoShowed }) => {
    const { authState } = useAuth()
    const [showAdditionalInfo, setShowAdditionalInfo] = useState(false)
    const [showWarehouses, setShowWarehouses] = useState(false)
    const [mouseOutside, setMouseOutside] = useState(false)
    const [showZipCodeInput, setShowZipCodeInput] = useState(false)
    const { isMobile } = useParams()

    useEffect(() => {
        if (setIsAvailabilityLevelAdditionalInfoShowed) {
            setIsAvailabilityLevelAdditionalInfoShowed(showAdditionalInfo)
        }
    }, [showAdditionalInfo])

    useEffect(() => {
        let timeout
        if (mouseOutside) {
            timeout = setTimeout(() => {
                if (mouseOutside) {
                    setShowAdditionalInfo(false)
                    setShowWarehouses(false)
                }
            }, 100)
        }
        return () => clearTimeout(timeout)
    }, [mouseOutside])

    const handleGetAvailabilityLevel = (e) => {
        e.stopPropagation()
        e.preventDefault()
        setShowZipCodeInput(true)
    }
    const handleZipCodeInput = (param) => {
        setShowZipCodeInput(false)
    }

    if (!product || product.length === 0) {
        return null
    }
    if (!authState.siteId) {
        return (<>
            <div onClick={(e) => e.stopPropagation()}>
                <ZipCodeInputModal
                    show={showZipCodeInput}
                    onHide={handleZipCodeInput}
                />
            </div>
            <div className='product-availability-level-main-container' onClick={handleGetAvailabilityLevel}>
                <span className='light-text-color me-3'>Poznaj dostępność</span>
            </div>
        </>)
    }

    const getAlignItemsStyle = () => {
        if (isMobile) {
            return ''
        }
        else {
            return product.availabilityLevelInOtherWarehouses.isAvailable ? 'center' : 'flex-start'
        }
    }

    var flexDirectionStyle = isMobile ? 'flex-column' : ''
    var availabilityTextStyle = isMobile ? 'secondary-text' : 'light-text-color'

    return (
        <>
            <div className={`product-availability-level-main-container ${flexDirectionStyle}`} style={{ alignItems: getAlignItemsStyle() }} onMouseEnter={() => setMouseOutside(false) || setShowAdditionalInfo(true)} onMouseLeave={() => setMouseOutside(true)}>
                <span className={`${availabilityTextStyle} me-3`}>Dostępność</span>
                <AvailabilityBattery
                    product={product}
                    availabilityTextStyle={availabilityTextStyle}
                />
                <AdditionalInfoSection
                    product={product}
                    showAdditionalInfo={showAdditionalInfo}
                    showWarehouses={showWarehouses}
                    setShowWarehouses={setShowWarehouses}
                    isMobile={isMobile}
                />
            </div>
        </>
    )
}

const AvailabilityBattery = ({ product, availabilityTextStyle }) => {
    if (product.availabilityLevelInOtherWarehouses.isAvailable) {
        return (
            <div style={{ display: 'flex', gap: '5px' }}>
                {[...Array(3)].map((_, index) => (
                    <div
                        key={index}
                        style={{
                            width: '1.5rem',
                            height: '0.5rem',
                            backgroundColor: index < product.availabilityLevel ? 'var(--primary)' : 'var(--no-availability)',
                        }}
                    ></div>
                ))}
            </div>)
    }
    else {
        return <span className={availabilityTextStyle}>{product.availabilityLevelInOtherWarehouses.productUnavailableText}</span>
    }
}

const AdditionalInfoSection = ({ product, showAdditionalInfo, showWarehouses, setShowWarehouses, isMobile }) => {
    const infoSwitchText = showWarehouses ? 'Zwiń szczegóły' : 'Pokaż szczegóły'
    const fontsStyle = isMobile ? 'mobile-font' : ''

    if (showAdditionalInfo && product.availabilityLevelInOtherWarehouses.otherWarehouses.length > 0) {
        return (<>
            <div className='product-availability-level-additional-info-container user-select-none'>
                <div className='d-flex flex-column mb-2'>
                    <div className={product.availabilityLevelInOtherWarehouses.localQty === 0 ? 'collapse' : ''}>
                        <GoDotFill className='me-2' size={12} style={{ color: 'var(--primary)' }} />
                        <span className={fontsStyle}>{`${product.availabilityLevelInOtherWarehouses.localQty} ${product.baseUnit} ${product.availabilityLevelInOtherWarehouses.localDesc}`}</span>
                    </div>
                    <div className={product.availabilityLevelInOtherWarehouses.regQty === 0 ? 'collapse' : ''}>
                        <GoDotFill className='me-2' size={12} style={{ color: 'var(--primary)' }} />
                        <span className={fontsStyle}>{`${product.availabilityLevelInOtherWarehouses.regQty} ${product.baseUnit} ${product.availabilityLevelInOtherWarehouses.regDesc}`}</span>
                    </div>
                    <div className={product.availabilityLevelInOtherWarehouses.macroQty === 0 ? 'collapse' : ''}>
                        <GoDotFill className='me-2' size={12} style={{ color: 'var(--primary)' }} />
                        <span className={fontsStyle}>{`${product.availabilityLevelInOtherWarehouses.macroQty} ${product.baseUnit} ${product.availabilityLevelInOtherWarehouses.macroDesc}`}</span>
                    </div>
                    <div className={product.availabilityLevelInOtherWarehouses.supplierStockQty === 0 ? 'collapse' : ''}>
                        <GoDotFill className='me-2' size={12} style={{ color: 'var(--primary)' }} />
                        <span className={fontsStyle}>{`${product.availabilityLevelInOtherWarehouses.supplierStockQty} ${product.baseUnit} ${product.availabilityLevelInOtherWarehouses.supplierStockDesc}`}</span>
                    </div>
                </div>
                <span onClick={() => setShowWarehouses(prev => !prev)} className='product-availability-level-additional-info-switch user-select-none'>{infoSwitchText}</span>
                {showWarehouses &&
                    <div className='mt-2'>
                        {product.availabilityLevelInOtherWarehouses.otherWarehouses.map(x => (
                            <div className='d-flex align-items-center' key={x.warehouseName}>
                                <GoDotFill className='me-2' size={12} style={{ color: 'var(--primary)' }} />
                                <span className={fontsStyle}>{`${x.warehouseName} - ${x.qty} ${product.baseUnit}`}</span>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </>)
    }
    else {
        return null
    }
}

export default ProductAvailabilityLevel

